import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import System from "@/model/system";
import LogRocket from "logrocket";

@Module({ namespaced: true })
export default class SystemModule extends VuexModule {
  public system: System;

  @Mutation
  set(system: System) {
    this.system = system
  }

  @Mutation
  setConfirm(flag: boolean) {
    this.system.is_close_a_y_c_confirm = flag;
  }

  @Action({ rawError: true })
  setSystem(system: System) {
    this.context.commit("set", system);
    LogRocket.identify(system.customer_token, {
      shop_token: system.shop_token,
      request_token: system.request_token,
      session_token: system.session_token,
      customer_token: system.customer_token,
      datetime: system.datetime,
    });
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", new System());
  }

  @Action({ rawError: true })
  setCloseAYCConfirm() {
    this.context.commit("setConfirm", true);
  }

  get getSystem(): System {
    if (this.system) {
      LogRocket.identify(this.system.customer_token, {
        shop_token: this.system.shop_token,
        request_token: this.system.request_token,
        session_token: this.system.session_token,
        customer_token: this.system.customer_token,
        datetime: this.system.datetime,
      });
    }

    return this.system
  }

  get isCloseAYCConfirm(): boolean {
    return this.system.is_close_a_y_c_confirm;
  }
}
